var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 3,
    viewBox: "0 0 17 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.34497 0C0.605237 0 0 0.605237 0 1.34497C0 2.08471 0.605237 2.68994 1.34497 2.68994C2.08471 2.68994 2.68994 2.08471 2.68994 1.34497C2.68994 0.605237 2.08471 0 1.34497 0ZM14.7903 0C14.0506 0 13.4453 0.605237 13.4453 1.34497C13.4453 2.08471 14.0506 2.68994 14.7903 2.68994C15.53 2.68994 16.1353 2.08471 16.1353 1.34497C16.1353 0.605237 15.53 0 14.7903 0ZM8.07153 0C7.3318 0 6.72656 0.605237 6.72656 1.34497C6.72656 2.08471 7.3318 2.68994 8.07153 2.68994C8.81127 2.68994 9.41651 2.08471 9.41651 1.34497C9.41651 0.605237 8.81127 0 8.07153 0Z",
    fill: "#F7B84B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.33b3ffea0e3ecd92527a50b7117cd5e4.svg";
export { ForwardRef as ReactComponent };